import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import { useField } from 'formik'
import { Box } from 'reflexbox/styled-components'

import { Input, Label, ErrorText } from './styles'

const NumberField = ({ label, ...props }) => {
  const [{ value, ...field }, meta, helpers] = useField(props)

  const isError = meta.touched && meta.error

  const defaultValue = Number(value)

  return (
    <Box sx={{ position: 'relative' }} {...props}>
      <Input
        type='text'
        error={isError ? 'true' : null}
        thousandSeparator='.'
        decimalSeparator=','
        defaultValue={defaultValue}
        onValueChange={({ value }) => helpers.setValue(value)}
        {...field}
        {...props}
        onChange={() => {}}
        as={NumberFormat}
      />

      {label && <Label>{label}</Label>}

      {isError && <ErrorText>{meta.error}</ErrorText>}
    </Box>
  )
}

NumberField.propTypes = {
  label: PropTypes.string,
  ...Box.propTypes,
}

export default NumberField
